export const TRACKER_PATH_NAME = 'tracker';
export const TRACKER_BULK_REQUEST_LIMIT = 40;
export const TRACKER_SKIP_REASON_OUT_OF_SCOPE = 'out_of_scope' as const;
